import React from 'react';
import { Page, Text, View, Document, Image, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 20,
  },
  section: {
    marginBottom: 10,
  },
  flexRow: {
    flexDirection: "row",
    justifyContent: 'space-between',
  },
  flexRowContent: {
    flexDirection: "row",
    justifyContent: 'space-between',
    marginTop: 40,
  },
  leftSection: {
    width: '47.5%',
  },
  rightSection: {
    marginLeft: '5%',
    width: '47.5%',
  },
  companySection: {
    justifyContent: 'flex-end',
  },
  companyName: {
    fontWeight: 'semibold',
    fontSize: 8,
    marginBottom: 2,
  },
  companyAddress: { fontSize: 8, marginBottom: 2 },
  dateSection: {
    marginTop: 20,
    marginBottom: 10,
  },
  pageHeading: {
    fontSize: 18,
    marginBottom: 5,
    paddingBottom: 3,
    fontWeight: 700,
  },
  pageSubheading: {
    flexDirection: 'column',
    marginBottom: 5,
  },
  subHeadingText: {
    width: '50%',
    fontSize: 13,
    fontWeight: 'bold',
  },
  subHeadingText2: {
    width: '50%',
    fontSize: 13,
    color: '#444444',
    fontWeight: 'semibold',
    fontStyle: 'italic',
  },
  heading: {
    fontSize: 12,
    marginBottom: 6,
    fontWeight: 'bold',
    //borderBottom: '1px solid #ccc',
    paddingBottom: 5,
  },
  fieldContainer: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  fieldLabel: {
    width: '50%',
    fontSize: 10,
    // fontWeight: 'semibold',
  },
  fieldValue: {
    width: '50%',
    fontSize: 10,
  },
  content: {
    fontSize: 10,
  },
  dateSectionTitle: { width: '25%', fontSize: 10 },
  dateSectionValue: { width: '25%', fontSize: 10 }
});

const FileOpeningPdf = ({ data }) => (
  <Document>
    <Page size="A4" style={styles.page} >
      <View style={styles.flexRow}>
        <View style={styles.section}>
          <Text style={styles.pageHeading}>File Opening & Ledger Request Sheet</Text>
          <View style={styles.pageSubheading}>
            <Text style={styles.subHeadingText}>Fee Earner's Responsibility</Text>
            <Text style={styles.subHeadingText2}>I have completed Initial Transaction Criteria.</Text>
          </View>
          <View style={styles.dateSection}>
            <View style={styles.fieldContainer}>
              <Text style={styles.dateSectionTitle}>Date:</Text>
              <Text style={styles.dateSectionValue}>{data.date}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.dateSectionTitle}>File Ref Number:</Text>
              <Text style={styles.dateSectionValue}>AA/SK/BHAM/{data.id}</Text>
            </View>
          </View>
        </View>
        <View style={styles.companySection}>
          <Image
            style={{
              marginBottom: 10,
              width: '60px',
              alignSelf: 'flex-end',
            }}
            src="/logo192.png"
          />
          <View>
            <Text style={styles.companyName}>SKA NANKANA SAHIB SOLICITORS</Text>
            <Text style={styles.companyAddress}>
              101A Soho Hill, Hockley,
            </Text>
            <Text style={styles.companyAddress}>
              Birmingham, B19 1AY.
            </Text>
            <Text style={styles.companyAddress}>
              <Text style={{ fontWeight: 'bold', marginRight: 3 }}>(T):</Text> 0121 493 4730 | 0121 493 4731
            </Text>
            <Text style={styles.companyAddress}>
              <Text style={{ fontWeight: 'bold', marginRight: 3 }}>(Emergency Only):</Text> 07869 720 081 |
            </Text>
            <Text style={styles.companyAddress}>
              07861 460 640
            </Text>
            <Text style={styles.companyAddress}>
              <Text style={{ fontWeight: 'bold', marginRight: 3 }}>(E):</Text>Office@SKASolicitors.co.uk
            </Text>
          </View>
        </View>
      </View>


      <View style={styles.flexRowContent}>
        <View style={styles.leftSection}>
          <View style={styles.section}>
            <Text style={styles.heading}>Client Details</Text>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldValue}>Surname:</Text>
              <Text style={styles.fieldValue}>{data.surname}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldValue}>Forename:</Text>
              <Text style={styles.fieldValue}>{data.forename}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldValue}>Title:</Text>
              <Text style={styles.fieldValue}>{data.title}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldValue}>Date of Birth:</Text>
              <Text style={styles.fieldValue}>{data.dob}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldValue}>Marital Status:</Text>
              <Text style={styles.fieldValue}>{data.marital_status}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldValue}>N.I. Number:</Text>
              <Text style={styles.fieldValue}>{data.ni_number}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldValue}>Ethnic Origin:</Text>
              <Text style={styles.fieldValue}>{data.ethnic_origin}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldValue}>Disability:</Text>
              <Text style={styles.fieldValue}>{data.disability}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldValue}>Immigration Status:</Text>
              <Text style={styles.fieldValue}>{data.immigration_status}</Text>
            </View>
          </View>
          <View style={styles.section}>
            <Text style={styles.heading}>Address</Text>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Number/Street:</Text>
              <Text style={styles.fieldValue}>{data.number_street}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>City:</Text>
              <Text style={styles.fieldValue}>{data.city}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Country:</Text>
              <Text style={styles.fieldValue}>{data.country}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Postal Code:</Text>
              <Text style={styles.fieldValue}>{data.postal_code}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Telephone:</Text>
              <Text style={styles.fieldValue}>{data.telephone}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Mobile:</Text>
              <Text style={styles.fieldValue}>{data.mobile}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>ID Carried Out:</Text>
              <Text style={styles.fieldValue}>{data.id_carried_out}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Evidence Relied Upon:</Text>
              <Text style={styles.fieldValue}>{data.evidence_relied_upon}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Name of Conflict Check:</Text>
              <Text style={styles.fieldValue}>{data.conflict_check}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Source of funding our costs::</Text>
              <Text style={styles.fieldValue}>{data.funding_source}</Text>
            </View>
          </View>
        </View>
        <View style={styles.rightSection}>
          <View style={styles.section}>
            <Text style={styles.heading}>Case Details</Text>
            <View style={styles.fieldContainer}>
              <Text style={styles.content}>{data.case_details}</Text>
            </View>
          </View>
          <View style={styles.section}>
            <Text style={styles.heading}>Proceeding Details</Text>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Venue:</Text>
              <Text style={styles.fieldValue}>{data.venue}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Stage:</Text>
              <Text style={styles.fieldValue}>{data.stage}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Key Date:</Text>
              <Text style={styles.fieldValue}>{data.key_date}</Text>
            </View>
          </View>

          <View style={styles.section}>
            <Text style={styles.heading}>Sponsor Details</Text>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Sponsor Name:</Text>
              <Text style={styles.fieldValue}>{data.sponsor_name}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Sponsor Number/Street:</Text>
              <Text style={styles.fieldValue}>{data.sponsor_number_street}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Sponsor City:</Text>
              <Text style={styles.fieldValue}>{data.sponsor_city}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Sponsor Country:</Text>
              <Text style={styles.fieldValue}>{data.sponsor_country}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Sponsor Postal Code:</Text>
              <Text style={styles.fieldValue}>{data.sponsor_postal_code}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Sponsor Telephone:</Text>
              <Text style={styles.fieldValue}>{data.sponsor_telephone}</Text>
            </View>
          </View>

          <View style={styles.section}>
            <Text style={styles.heading}>Lawyer Costs</Text>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Fee Earner:</Text>
              <Text style={styles.fieldValue}>{data.fee_earner}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Fixed Fee:</Text>
              <Text style={styles.fieldValue}>{data.fixed_fee_agreed}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Fixed Fee Agreed:</Text>
              <Text style={styles.fieldValue}>{data.fixed_fee}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Hourly Rate:</Text>
              <Text style={styles.fieldValue}>{data.hourly_rate_agreed}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Hourly Rate Agreed:</Text>
              <Text style={styles.fieldValue}>{data.hourly_rate}</Text>
            </View>
            <View style={styles.fieldContainer}>
              <Text style={styles.fieldLabel}>Alternative Cost:</Text>
              <Text style={styles.fieldValue}>{data.alternative_cost}</Text>
            </View>
          </View>

        </View>
      </View>



      <View style={styles.section}>
        <View style={styles.fieldContainer}>
          <Text style={{ fontSize: 12, fontWeight: 'bold', marginRight: 5 }}>Completed By:</Text>
          <Text style={{ fontSize: 10, marginTop: 2 }}><Text>{data.completed_by}</Text></Text>
        </View>
      </View>

      <View style={{ position: 'absolute', bottom: 20, right: 20, left: 20, alignItems: 'flex-end' }}>
        <View style={{ display: 'flex', alignItems: 'flex-end' }}>
          <View>
            <Text style={{ fontSize: 10, marginTop: 2 }}>
              On receipt of file complete:
            </Text>
            <Text style={{ fontSize: 10, marginTop: 2 }}>
              1. <Text style={{ fontWeight: 'bold' }}>Specific Client Care Letter</Text>.
            </Text>
            <Text style={{ fontSize: 10, marginTop: 2 }}>
              2. <Text style={{ fontWeight: 'bold' }}>Account Form 1</Text> requesting invoice.
            </Text>
            <Text style={{ fontSize: 10, marginTop: 2 }}>
              3. <Text style={{ fontWeight: 'bold' }}>Account Form 2</Text> if fee received.
            </Text>
            <Text style={{ fontSize: 10, marginTop: 2 }}>
              4. <Text style={{ fontWeight: 'bold' }}>Account Form 3</Text> if client money received, as appropriate.
            </Text>
          </View>
        </View>
      </View>
    </Page>
  </Document >
);

export default FileOpeningPdf;
